/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type LinkAccountContainerLocal = {
    readonly duplicateEmail: string | null;
    readonly " $refType": "LinkAccountContainerLocal";
};
export type LinkAccountContainerLocal$data = LinkAccountContainerLocal;
export type LinkAccountContainerLocal$key = {
    readonly " $data"?: LinkAccountContainerLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"LinkAccountContainerLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "LinkAccountContainerLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "duplicateEmail",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = '351ef13bedf01848ebe32d54dfca7e8a';
export default node;
